export const transmissionModalState = {
  isReportUnsigning: false,
  signingModalState: "",
  isProcessModal: false,
  isArchiveModal: false,
  isBillingModal: false,
  isDownloadModal: false,
  isHl7JobModal: false,
  isSigningModal: false,
  isProcessing: false,
  isArchiving: false,
  isReportArchiving: false,
  isReportProcessing: false,
  isReportUnProcessing: false,
  isSignAndProcessing: false,
  isSignAndUnProcessing: false,
  isNextSendModal: false,
  isPhysicianModal: false,
  isPatientModal: false,
  isReportDetailModal: false,
  isPreviousAlertModal: false,
  isPreviousReportModal: false,
  isPdfModal: false,
  previousReportId: "",
  isPreviousReportLegacy: null,
  previousReportBillingCode: null,
  processModalState: "",
  nextSendDate: "",
  nextSendInformation: null,
  physicians: [],
  isAlertNotificationModal: false,
  isSignAndProcessModal: false,
  showMissingPatientDetailModal: false,
  isPhysicianUnprocessFromClinicProcessedModal: false,
};
